// src/App.js
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Homepage from './components/pages/Homepage';
import Propertypage from './components/pages/Propertypage';
import Allpropertypage from './components/pages/Allpropertypage';
import Spacedetailspage from './components/pages/Spacedetailspage';
import Allspacepage from './components/pages/Allspacepage';
import Contact from './components/Contact/Contact';
import Commercialpage from './components/pages/Commercialpage';
import Loftpage from './components/pages/Loftpage';
import Commercialspage from './components/pages/Commercialspage';
import Retailpage from './components/pages/Retailpage';
import Privacypage from './components/pages/Privacypage';
import Termspage from './components/pages/Termspage';


/* ---------- ScrollToTop Component ---------- */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => (
  <>
    {/* Ensure page scrolls to top on route change */}
    <ScrollToTop />

    <Routes>
      <Route path='/' element={<Homepage />} />



      <Route path='/contact' element={<Contact />} />


      <Route path='/spaces/lofts' element={<Loftpage />} />
      <Route path='/spaces/commercial' element={<Commercialspage />} />


      <Route path='/privacy-policy' element={<Privacypage />} />
      <Route path='/Terms&conditions' element={<Termspage />} />


      <Route path='/commercial-tenants' element={<Commercialpage />} />



    </Routes>
  </>
);

export default App;
